import { ProfileBaseLayout } from './_base-layout/ProfileBaseLayout'

export const ProfilePageLayout = (page) => {
  return (
    <ProfileBaseLayout metaProps={page?.props?.metaProps}>
      {page}
    </ProfileBaseLayout>
  )
}

export const ProfilePageLayoutWithoutProfileBar = (page) => {
  return (
    <ProfileBaseLayout isProfileBarVisible={false}>{page}</ProfileBaseLayout>
  )
}
